import * as React from 'react';
import clx from 'classnames';
import { Col, Typography, Card, Steps, Space } from 'antd';
const { Title } = Typography;
const { Step } = Steps;

import { FormWidgetSwitch } from 'client/components/schema/widget/form/switch/FormWidgetSwitch';
import { IWidget } from 'common/schema/widget/Widget';
import { PageMobileOnlyColumn } from 'client/ui/layout/page/PageMobileOnlyColumn';
import { PageMainColumn } from 'client/ui/layout/page/PageMainColumn';
import { ProcedureMobileTopFormTitle } from './ProcedureMobileTopFormTitle';
import { useState } from 'react';
import { PageDesktopOnlyRow } from 'client/ui/layout/page/PageDesktopOnlyRow';
import { VerticalSpace } from 'client/ui/space/VerticalSpace';
import { useRequestCompileContext } from 'client/components/schema/requests/compile-context/RequestCompileContext';
import { WidgetDisposalStepLogic } from 'common/schema/widget/disposal/WidgetDisposalStepLogic';
import { useRequestSteps } from 'client/components/schema/requests/compile-context/useRequestSteps';
import { ProcedureTopFormTitle } from './ProcedureTopFormTitle';
import { StepTitleTooltip } from './StepTitleTooltip';
import { ProcedureSteps } from './ProcedureSteps';

export interface ProcedureFormMainColumnProps {
  procedureTitle?: string;
  beforeContent?: React.ReactNode;
  afterContent?: React.ReactNode;
}

/**
 * Modulo di una domanda (colonna sinistra)
 * che include la lista dei Widget e l'alert di errore
 *
 * Questo elemento è condiviso anche con la pagina di Anteprima lato Admin
 */
export function ProcedureFormMainColumn(props: ProcedureFormMainColumnProps) {
  const { procedureTitle, beforeContent, afterContent } = props;

  const steps = useRequestSteps();

  return (
    <>
      {/* Colonna Titolo Solo Mobile | Alternativa al Titolo Full Page */}
      {/* <PageMobileOnlyColumn>
        <ProcedureMobileTopFormTitle children={procedureTitle} />
      </PageMobileOnlyColumn> */}

      {/* Titolo Full Page Giustificato*/}
      <ProcedureTopFormTitle children={procedureTitle} />

      {/* Colonna Principale */}
      <PageMainColumn>
        <ProcedureSteps steps={steps.steps} currentIndex={steps.currentIndex} />
        <Card size="small">
          {beforeContent}
          {steps.current.widgets.map((widget, key) => (
            <FormWidgetSwitch key={widget.id} widget={widget} />
          ))}
        </Card>
        {afterContent}
      </PageMainColumn>
    </>
  );
}
